<div class="back-img">
    <div style="position: sticky; left: 0; top: 0; z-index: 10;">
        <label class=" urllabel">BharatBhuVikas.com</label>
    </div>
    <div class="row" style="--bs-gutter-x: 0rem;--bs-gutter-y:0rem;">
        <div class="col-md-8 offset-md-2">
            <div class="text-center welcomeLabel"><span> The Future of Bharat's
                    Land Assets
                    is Under Construction</span></div>
        </div>
        <div class="tagline-subtitle text-center col-md-8 offset-md-2">
            Be the first to access the Aggregator Engine.
            <br />
            Join the early-access waitlist.
        </div>
        <div>
            <div class="text-center d-flex flex-column flex-md-row justify-content-center align-items-center">
                <input type="email" class="col-md-3 form-control form-control-lg mt-4" placeholder="Enter your email">
                <button class="btn btn-notify btn-lg mt-4 ms-md-2" (click)="notifyme()">Notify Me</button>
            </div>
        </div>
        <div class="copyright">
            {{copyrightMessage}}
        </div>
    </div>
</div>